/* eslint-disable no-else-return */
import React, { useState } from 'react';
import qs from 'querystringify';
import { useStoreState } from 'easy-peasy';
import { IoMdRefresh } from 'react-icons/io';

import styled from 'styled-components';
import uuidv4 from 'uuid/v4';
import Layout from '../../../components/global/Layout';
import { Pagination } from '../../../components/elements';
import Header from './Header';
import Search from './Search';
import { useData } from './helpers';
import DataTable from './DataTable';

const RefreshWrapper = styled.div`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const NoSchedulerPlaces = ({ history, location }) => {
  const { userId: adminUserId } = useStoreState(state => state.auth);

  const routeState = qs.parse(location.search);
  const { page, placeFilter } = routeState;

  const currentPage = parseInt(page, 10) - 1 >= 0 ? parseInt(page, 10) - 1 : 0;

  const [triggerRerender, setTriggerRerender] = useState(uuidv4());

  const handleChange = args => {
    history.push(
      `/without-schedulers${qs.stringify(
        {
          ...routeState,
          page: 1,
          ...args,
        },
        true,
      )}`,
    );
  };

  const [loadingData, data, totalSize, totalPages, ,] = useData({
    adminUserId,
    from: currentPage * 50,
    size: 50,
    placeName: placeFilter,
    triggerRerender,
  });

  return (
    <Layout>
      <Header />
      <Search handleChange={handleChange} placeName={placeFilter} />
      <RefreshWrapper>
        <a
          onClick={() => {
            setTriggerRerender(uuidv4());
          }}
          className="button is-grey"
        >
          <span className="is-flex is-justify-content-center is-align-items-center has-text-weight-semibold">
            <IoMdRefresh size={24} /> Refresh data
          </span>
        </a>
      </RefreshWrapper>
      <div className="mb-4">&nbsp;</div>
      {totalSize > 0 && (
        <Pagination
          pageFrom={currentPage * 50}
          pageCount={totalPages}
          listSize={50}
          totalElements={totalSize}
          currentPage={currentPage}
          handlePageClick={value => {
            history.push(
              `/without-schedulers${qs.stringify(
                {
                  ...routeState,
                  page: value.selected + 1,
                },
                true,
              )}`,
            );
          }}
        />
      )}
      <DataTable loading={loadingData} data={data} history={history} />
    </Layout>
  );
};

export default NoSchedulerPlaces;
